module.exports = __webpack_public_path__ + "media/latwy_hover.cf3ed108.mp3";